import React from 'react';

import Button from '../../library/button/button';
import Typography from '../../library/typography/typography';
import SearchButtonGroup from './components/search-button-group/search-button-group';
import { CheckCircleSolidIcon } from '../../shared/icons/icons';

import './search-button.scss';

interface SearchButtonProps {
  className?: string;
  href?: string;
  isSelected?: boolean;
  label?: string | React.ReactNode;
  onClick?: () => void;
  showIcon?: boolean;
}

function SearchButton(props: React.PropsWithChildren<SearchButtonProps>) {
  const {
    children,
    className = '',
    href,
    isSelected,
    label,
    onClick,
    showIcon
  } = props;

  return (
    <Button
      data-testid="search button"
      href={href}
      onClick={onClick}
      styleName="search-btn"
    >
      <div
        aria-selected={isSelected}
        className={className}
        role="gridcell"
        styleName={isSelected ? 'selected-container' : 'container'}
      >
        <Typography size="small" styleName="label" tag="div" weight="black">
          {label}
        </Typography>
        {isSelected && showIcon && (
          <div styleName="icon">
            <CheckCircleSolidIcon />
          </div>
        )}
        <div styleName="image-container">{children}</div>
      </div>
    </Button>
  );
}

export { SearchButtonGroup };
export default SearchButton;
